import { userService } from "../services";
import config from "../config/config";

export const AddressAction = {
  AddressList,
  InstalledGps,
  KmlFileUpload,
  KmlFileUploadUpdate,
  ConvertLatTngToAddress,
};

async function AddressList(payload, showSnackbar) {
  // debugger
  try {
    let apiEndpoint = `${
      JSON.parse(sessionStorage.getItem("data")).addressUrl
    }`;
    // let apiEndpoint =  `http://eclvts.com/watsoo-locationconverter/address/v1/fetch_address`

    // https://eclvts.com/watsoo-locationconverter/address/v1/fetch_address

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200 && 201) {
      return response.data;
    } else {
      console.log(response);
      if (response.status != 500) {
      }
      if (response.status == 401) {
        showSnackbar(response.data.message, "error");
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function InstalledGps(payload, type, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.totalInstallGps}`;
    if (!type) {
      payload.forDropDown = true;
    }
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (response.status != 500) {
      }
      if (response.status == 401) {
        showSnackbar(response.data.message, "error");
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function KmlFileUpload(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.KmlFileUploding}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);

    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);

      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function KmlFileUploadUpdate(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.updateKmlDataRoute}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);

    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);

      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

// async function ConvertLatTngToAddress(lat, long, showSnackbar) {
//   // https://ais.watsoo.com/address/26.7241181/88.417202
//   try {
//     const addressBaseUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`;
//     // let addressBaseUrl = `https://mcl.watsoo.com/address/${lat}/${long}`;

//     let response = await userService.get(addressBaseUrl);
//     // console.log(response, "zsdxfcgvhbjnkm");
//     if (response && response.status == 200 && 201) {
//       return { add: response?.data?.display_name };
//     } else {
//       if (response.status != 500) {
//       }
//       if (response.status == 401) {
//         showSnackbar(response.data.message, "error");
//       }
//       return null;
//     }
//   } catch (error) {
//     console.log("error", error);
//     return null;
//   }
// }

const queue = [];
let isProcessing = false;

const processQueue = async () => {
  if (isProcessing || queue.length === 0) return;
  isProcessing = true;
  const { lat, lng, resolve } = queue.shift();
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
    );

    const data = await res.json();
    resolve({ add: data?.display_name } || `${lat}, ${lng}`);
  } catch {
    resolve(`${lat}, ${lng}`);
  }

  setTimeout(() => {
    isProcessing = false;
    processQueue();
  }, 200); // 🔥 1 second delay (IMPORTANT)
};

async function ConvertLatTngToAddress(lat, lng) {
  return new Promise((resolve) => {
    queue.push({ lat, lng, resolve });
    processQueue();
  });
}
